import styled from "styled-components";

export const RowContainer = styled.div`
    width: 100%;
    height: 14%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
`
export const TypeText = styled.span`
    font-size:1rem;
    color: #DFDDE8;
`